export const CLEAR_DATA = "CLEAR_DATA";
export const HYDRATE_STATE = "HYDRATE_STATE";
export const REACT_NATIVE = "REACT_NATIVE";

export function clearData(agent) {
    return {
        type: CLEAR_DATA,
        agent
    };
}

export function hydrateState(newState) {
    return {
        type: HYDRATE_STATE,
        newState
    };
}
